// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bd188ceb","389":"af67332e","455":"598f78dd","977":"792f2b64"}[chunkId] + ".chunk.js";
};